export default __webpack_public_path__ + "static/media/nica-logo.0c0d1ec5.svg";